/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './ToggleCheck.module.scss';

function ToggleCheck({
  labels, name, isChecked, onValueChange, disabled, className, isRequired, fontSize,
}) {
  return (
    <div className={className || ''}>
      <div className={`${styles.toggle_checkbox} d-flex a-center`}>
        {labels.length > 1 ? (
          <label
            htmlFor={name}
            className={`
              ${isChecked ? styles.checked : ''} 
              ${styles.second_label} 
              fs-16 ${fontSize || ''}
            `}
          >
            {labels[0]}
          </label>
        ) : null}
        <label htmlFor={name}>
          <input
            type="checkbox"
            id={name}
            name={name}
            checked={isChecked}
            onChange={(input) => onValueChange(input.target.checked)}
            disabled={disabled}
          />
          <span className={`${styles.slider} ${labels.length > 1 ? styles.double : ''}`} />
          <div
            className={`
                ${labels.length > 1 ? styles.with_second_label : ''} 
                ${isChecked ? styles.checked : ''} 
                fs-16 ${fontSize || ''}
              `}
          >
            {labels[labels.length > 1 ? 1 : 0]}
            {isRequired ? <span className="c-primary-500">*</span> : null}
          </div>
        </label>
      </div>
    </div>
  );
}

ToggleCheck.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  onValueChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  fontSize: PropTypes.string,
};

ToggleCheck.defaultProps = {
  isChecked: false,
  onValueChange: () => {},
  disabled: false,
  className: null,
  isRequired: false,
  fontSize: null,
};

export default ToggleCheck;
